const aboutMe = {
    fullname: "Alexis Zamanidis",
    location: "Athens, Greece",
    dateOfBirth: "1998-01-20",
    summary:
        "I am currently an undergraduate student at National and Kapodistrian University of Athens in Department of Informatics and Telecommunications.",
    image: "https://drive.google.com/uc?id=1TjlxLKkrl6fVg6GZLtdaJlIFb2Ojspv7",
    cv: "https://drive.google.com/uc?id=1gqb_C5kko846r6uYC7grd1VRfaSxjwuG",
    skills: [
        {
            name: "Languages",
            tools: "C, C++, Java",
        },
        {
            name: "Data Science",
            tools: "Python",
        },
        {
            name: "Frontend",
            tools: "JavaScript, HTML, CSS, React",
        },
        {
            name: "Backend",
            tools: "PHP, Spring Boot",
        },
        {
            name: "Databases",
            tools: "MySQL",
        },
        {
            name: "Other Tools",
            tools: "Git, Balsamiq, Lucidchart",
        },
    ],
    passionateAbout: [
        {
            name: "Frontend Web Development mainly with React",
        },
        {
            name: "Backend Web Development mainly with Spring Boot",
        },
        {
            name: "Machine Learning - Data Mining",
        },
        {
            name: "Parallel Programming",
        },
    ],
    hobbies: [
        {
            name: "Playing Football and Basketball",
        },
        {
            name: "Calisthenics Workout",
        },
    ],
};

const gitHubDetails = {
    username: "alexiszamanidis",
    profileLink: "https://github.com/alexiszamanidis",
};

const gitLabDetails = {
    username: "alexiszamanidis",
    profileLink: "https://gitlab.com/alexiszamanidis",
};

const linkedInDetails = {
    profileLink: "https://linkedin.com/in/alexiszamanidis",
};

const navLinks = [
    {
        nav_item_class_name: "nav_item",
        link_class_name: "nav_link",
        to: "AboutMe",
        smooth: true,
        offset: -70,
        duration: 600,
        text: "About me",
    },
    {
        nav_item_class_name: "nav_item",
        link_class_name: "nav_link",
        to: "Portfolio",
        smooth: true,
        offset: -70,
        duration: 600,
        text: "Portfolio",
    },
    {
        nav_item_class_name: "nav_item",
        link_class_name: "nav_link",
        to: "Contact",
        smooth: true,
        offset: -70,
        duration: 600,
        text: "Contact",
    },
];

export { aboutMe, gitHubDetails, gitLabDetails, linkedInDetails, navLinks };
